import { IIconProps } from "../types"

export default function IconUR4(props: IIconProps) {
  const width = props.size || props.width || 74
  const height = props.size || props.height || 87
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 74 87"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.1379 1.53303C29.8779 0.82303 33.0679 0.49303 36.3179 0.98303C39.5779 1.47303 42.8979 2.77303 45.7279 5.08303C48.5579 7.39303 50.9079 10.713 53.2179 14.033C55.5279 17.353 57.8079 20.673 60.1179 24.453C62.4279 28.233 64.7679 32.463 66.5679 35.973C68.3479 39.493 69.5879 42.293 70.5379 44.833C71.4779 47.373 72.1279 49.643 72.3579 51.833C72.5879 54.013 72.3879 56.093 71.7079 58.243C71.0179 60.393 69.8479 62.603 67.7679 65.373C65.6879 68.133 62.6879 71.453 59.0079 74.773C55.3279 78.093 50.9679 81.423 47.7779 83.473C44.5879 85.523 42.5679 86.303 39.1879 86.173C35.7979 86.043 31.0479 85.003 26.4279 83.563C21.8079 82.133 17.3079 80.313 13.4079 77.573C9.49788 74.843 6.17788 71.193 4.06788 68.233C1.94788 65.273 1.03788 62.993 0.807876 57.953C0.577876 52.903 1.03788 45.093 2.10788 37.243C3.18788 29.403 4.87788 21.523 6.92788 16.053C8.97788 10.583 11.3879 7.52303 14.7379 5.44303C18.0879 3.36303 22.3879 2.25303 26.1379 1.53303Z"
        fill="#E6E6E6"
        stroke="black"
        strokeWidth="1.5"
        strokeMiterlimit="2.61313"
      />
    </svg>
  )
}
